<template>
  <v-container class="py-8">
    <h1 class="text-h4 mb-2">
      {{ $t("\n      Administration\n    ") }}
    </h1>
    <p>{{ $t("Monitor growth and campaigns, manage support, and configure the app.") }}</p>
    <v-tabs
      show-arrows
      class="mb-6"
    >
      <v-tab to="/admin/growth">
        {{ $t("\n        Growth dashboard\n      ") }}
      </v-tab>
      <v-tab to="/admin/support">
        {{ $t("\n        Support messages\n      ") }}
      </v-tab>
      <v-tab to="/admin/affiliates">
        {{ $t("\n        Affiliate administration\n      ") }}
      </v-tab>
      <v-tab to="/admin/settings">
        {{ $t("\n        App Settings\n      ") }}
      </v-tab>
    </v-tabs>
    <router-view />
  </v-container>
</template>
<script>
export default { name: 'AdminArea' }
</script>
